/**
 * Implements an Admin route interceptor as a behavior.
 *
 * It must attached to the main layout.
 */

import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import { createModal } from "../utils";

import AccountModel from "../models/admin/account-form";
import Create from "../views/admin/accounts/add";
import Edit from "../views/admin/accounts/edit";

const globalChannel = Radio.channel("global");
const reportChannel = Radio.channel("report");

class Admin extends Marionette.Behavior {
  initialize() {
    this.listenTo(reportChannel, "admin.accounts:create", this.onCreate);
    this.listenTo(reportChannel, "admin.accounts:edit", this.onEdit);
  }

  onCreate() {
    const View = Create.extend({
      el: createModal(),
    });

    this._createView(View, AccountModel);
  }

  onEdit(options) {
    const View = Edit.extend({
      el: createModal(),
    });

    this._createView(View, AccountModel, { id: options.id });
  }

  _createView(View, Model, modelOptions = {}) {
    // instantiate view, pass model instance
    new View({
      model: new Model(modelOptions),
    });
  }

  _updateStatus(type, message) {
    globalChannel.trigger("status:show", {
      type,
      message,
      autoDismissTimeout: 5000,
    });
  }
}

export { Admin as default };
